import React from 'react'
import { state } from '../../context/store'
import { useSnapshot } from 'valtio'
import { PremButton, HorizontalScroller, Button, Column } from '../Blocks'
import styled from 'styled-components'
import { productChoices } from '../../context/productChoices'
import { modeMethods } from '../../utilities/modeMethods'

const ModeButtonContainer = ({ section, wrap = 'wrap', maxWidth = '100%' }) => {
  const snap = useSnapshot(state.current)
  const productSnap = useSnapshot(productChoices.current)
  // console.log(section)
  // console.log(snap.choices[section].modes)
  let group

  if (section === 'sideLogos') {
    group = productSnap.choices[snap.initialChoices.type.index].badges
    // console.log(group)
  } else {
    group = snap.choices[section].modes
  }
  const changeMode = (section, choice) => {
    // console.log(section, choice)
    // console.log("ABRV", choice.abrv)
    state.current.choices[section].selected.mode = choice.mode
    if (choice.abrv) {
      state.current.choices[section].selected.abrv = choice.abrv
    }
    if (choice.name) {
      state.current.choices[section].selected.name = choice.name
    }
  }

  // console.log(group)

  return (
    <Wrap $wrap={wrap} $maxWidth={maxWidth}>
      {/* {snap.choices[section].selected.mode} */}
      {group.map((choice, index) => {
        const hasCustomMethod = choice.modeMethod && modeMethods[choice.modeMethod]

        const handleClick = () => {
          if (hasCustomMethod) {
            {/* console.log(`Calling custom method for ${choice.modeMethod}`)  */ }
            modeMethods[choice.modeMethod]() // call custom function
          } else {
            changeMode(section, choice) // fallback
          }
        }

        return (
          <Button
            key={`${section}-${choice.name}`}
            isDisabled={choice.broke}
            colorName={choice.name}
            price={choice.price}
            selected={snap.choices[section].selected.mode === choice.mode}
            handleClick={handleClick}
          // onClick={() => setActiveIndex(index)}
          >
            {snap.choices[section].selected.mode === choice.mode && choice.altText
              ? choice.altText
              : choice.name}

            {choice.price > 0 && <span className="price"> +${choice.price}</span>}
          </Button>
        )
      })}
    </Wrap>
  )
}

export default ModeButtonContainer

const Wrap = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: ${(props) => props.$width};
  flex-wrap: ${(props) => props.$wrap};

  & .price {
    margin-left: 0.3ch;
  }

  @media (width > 800px) {
    max-width: ${(props) => `min(${props.$maxWidth}, 100%)`};
  }
`
